import { createContext } from 'react';
import { createContextualCan } from '@casl/react';
import defineAbilityFor, { AppAbilityType } from '../defineAbility';

export const AbilityContext = createContext<AppAbilityType>(defineAbilityFor());

export const Can = createContextualCan(AbilityContext.Consumer);
